import { callFunction } from "./functions-client";

// Fleet-OS F7 — fuel log + IFTA quarterly summary. Owner-private, web console.
export const FUEL_TYPES = ["diesel", "def", "gas"] as const;
export type FuelType = (typeof FUEL_TYPES)[number];
export const FUEL_LABELS: Record<FuelType, string> = { diesel: "Diesel", def: "DEF", gas: "Gasoline" };

export interface FuelPurchase {
  id: string; vehicle_id: string | null; purchased_at: string; quarter: string;
  jurisdiction: string | null; gallons: number; total_cents: number | null;
  odometer: number | null; fuel_type: FuelType; vendor: string | null;
}
export interface MileRow { id: string; vehicle_id: string | null; quarter: string; jurisdiction: string; miles: number }
export interface IftaRow {
  jurisdiction: string; miles: number; taxable_gallons: number; purchased_gallons: number; net_gallons: number;
}
export interface IftaSummary {
  quarter: string; mpg: number; rows: IftaRow[];
  totals: { miles: number; purchased_gallons: number; taxable_gallons: number };
}

/** The IFTA quarter label for a date (client mirror of the server helper). */
export function quarterOf(d = new Date()): string {
  return `${d.getUTCFullYear()}-Q${Math.floor(d.getUTCMonth() / 3) + 1}`;
}

export const addPurchase = (input: {
  gallons: number; vehicle_id?: string; purchased_at?: string; total_cents?: number;
  odometer?: number; jurisdiction?: string; fuel_type?: FuelType; vendor?: string; notes?: string;
}) => callFunction<{ id: string; quarter: string }>("fuel/purchase-add", { body: input });

export const listPurchases = (quarter?: string, vehicle_id?: string) => {
  const p = new URLSearchParams();
  if (quarter) p.set("quarter", quarter);
  if (vehicle_id) p.set("vehicle_id", vehicle_id);
  const qs = p.toString();
  return callFunction<{ purchases: FuelPurchase[] }>(`fuel/purchases${qs ? `?${qs}` : ""}`, { method: "GET" });
};

export const deletePurchase = (id: string) =>
  callFunction<{ ok: boolean }>("fuel/purchase-delete", { body: { id } });

export const setMiles = (input: { quarter: string; jurisdiction: string; miles: number; vehicle_id?: string }) =>
  callFunction<{ ok: boolean }>("fuel/miles-set", { body: input });

export const listMiles = (quarter?: string) =>
  callFunction<{ miles: MileRow[] }>(`fuel/miles${quarter ? `?quarter=${encodeURIComponent(quarter)}` : ""}`, { method: "GET" });

export const iftaSummary = (quarter: string) =>
  callFunction<IftaSummary>(`fuel/ifta-summary?quarter=${encodeURIComponent(quarter)}`, { method: "GET" });
